var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"id":"fvl-snackbar","value":_vm.snack,"multi-line":"","color":_vm.colorSnack,"timeout":"-1"},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"white","text":""},on:{"click":_vm.hideSnackBar}},'v-btn',attrs,false),[_c('v-icon',[_vm._v(" close ")])],1)]}}])},[_vm._v(" "+_vm._s(_vm.snackbarMessage)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }